import { API } from "../utils";

export const getPlans = async ({ params }) => {
  const response = API.get("/plans", {
    params,
  });
  const data = await response;
  return data;
};

export const storePlan = async ({ body }) => {
  const response = API.post("/organization/plans", body);
  const data = await response;
  return data;
};

export const getCustomPlanConfigs = async ({ params }) => {
  const response = API.get("/organization/custom-plans-config", {
    params,
  });
  const data = await response;
  return data;
};

export const postReqPayment = async ({ body }) => {
  const response = API.post("/organization/payment-gateway", body);
  const data = await response;
  return data;
};
